export default __webpack_public_path__ + "static/media/cod001.2302d2b3.svg";